import { globalObject } from '../globalObject';
export function normalizeUrl(url) {
  return buildUrl(url, location.href).href;
}
export function isValidUrl(url) {
  try {
    return !!buildUrl(url);
  } catch (_a) {
    return false;
  }
}
export function getPathName(url) {
  var pathname = buildUrl(url).pathname;
  return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
export function buildUrl(url, base) {
  var _getPristineWindow = getPristineWindow(),
    URL = _getPristineWindow.URL;
  try {
    return base !== undefined ? new URL(url, base) : new URL(url);
  } catch (error) {
    throw new Error("Failed to construct URL: ".concat(String(error)));
  }
}
/**
 * Get native URL constructor from a clean iframe
 * This avoids polyfill issues by getting the native implementation from a fresh iframe context
 * Falls back to the original URL constructor if iframe approach fails
 */
var getPristineGlobalObjectCache;
export function getPristineWindow() {
  if (!getPristineGlobalObjectCache) {
    var iframe;
    var pristineWindow;
    try {
      iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      pristineWindow = iframe.contentWindow;
    } catch (_a) {
      pristineWindow = globalObject;
    }
    getPristineGlobalObjectCache = {
      URL: pristineWindow.URL
    };
    iframe === null || iframe === void 0 ? void 0 : iframe.remove();
  }
  return getPristineGlobalObjectCache;
}